<template>
  <v-main>
    <v-container class="fill-height" fluid>
        <v-card class="mx-auto">
          <v-card-title><router-link to="/profiles">Back to profiles</router-link></v-card-title>
          <v-toolbar
            color="buttons"
            dark
          >
            <v-toolbar-title>Profile Subscription</v-toolbar-title>
            <v-progress-linear
              :active="loading"
              :indeterminate="loading"
              absolute
              bottom
              color="deep-purple accent-4"
            ></v-progress-linear>
          </v-toolbar>

          <v-card-text>
            <div class="column">
          <div class="ui red header" v-if="error != ''"> {{ error }}</div>
          <div v-if="!paidFor">
              <v-alert
                border="bottom"
                outlined colored-border
                type="warning"
                elevation="2"
                v-model="alert"
                dismissible
              >
                Hi,<br>You are have been redirected to this page because you just created a profile or your last subscription  on this profile has expired. You require a subscription to continue to this profile.
              </v-alert>
              <p class="ui raised red left aligned segment" id="text"></p>
              <p class="text-h6 text-center text-uppercase">mi-SOS One Year Subscription</p>
              <v-alert success  color="green" class="text-center text-uppercase h2">Just for <strong>£{{product.price}}</strong></v-alert>
              <v-alert outlined class="text-body-2">{{ product.description }}</v-alert>
              <div class="" ref="paypal"></div>
          </div>

          <v-alert v-if="verifying" border="bottom" outlined colored-border type="warning" elevation="2">
                <p>Verifying payment, please wait!</p>
              </v-alert>
          <v-alert
            v-if="completed"
            dense
            text
            type="success"
          >
            <strong>Thank you, Payment completed</strong> 
            <p>You can now access your <v-btn outlined color="buttons" @click="paid">Profile</v-btn></p>
          </v-alert>

        </div>
          </v-card-text>
        </v-card>
      </v-container>
  </v-main>

</template>

<script>
export default {
    created: function() {
        const script = document.createElement("script");
      script.src =
      "https://www.paypal.com/sdk/js?currency=GBP&client-id=ASoh_jloAlGsWMmxE-JjgQQyvyQ3DVocMAfBJpvrGW67x95Yl3zC-BwyCj4e-7tJSnMxb0FGHmKuYRNa&vault=true";
      //  script.src =
      //"https://www.paypal.com/sdk/js?currency=GBP&client-id=ATPWI-DGQKUwLYQOXoBO9NByVFWXs_4fUR2CkI28qUMboyaLGD5C4Wc63iLVOQEfwzoXyVwo4g_nIYZm";

        script.addEventListener("load", this.setLoaded);
        document.body.appendChild(script);
    },
    components : {
      //
    },
    data: function() {
    return {
      alert: true,
      loading: false,
      verifying: false,
      completed:false,
      loaded: false,
      paidFor: false,
      error: '',
      product: {
        price: 12.00,
        description: "Subscribe for one year to enter and customise your details",
        img: "./assets/lamp.jpg",
        currency: 'GBP'
      }
    };
  },
  methods: {
    setLoaded: function() {
      this.loaded = true;
      window.paypal
        .Buttons({
          createOrder: (data, actions) => {
            return actions.order.create({
              purchase_units: [
                {
                  description: this.product.description,
                  amount: {
                    currency_code: this.product.currency,
                    value: this.product.price,
                  }
                }
              ]
            });
          },
          onApprove: async (data, actions) => {
            this.loading = true;
            const order = await actions.order.capture();
            if (order.status == "COMPLETED") {
              this.paidFor = true
              this.verifying = true
                //send infomation to server here
                this.$store.dispatch('user/aSubscribe', data)
                .then(response => {
                  if (response) {
                    this.verifying = false
                    this.completed = true
                    this.loading = false
                  }
                })

            } else  {
                this.error = "Payment failed, refresh window and try again"
            }

          },
          onError: err => {
            this.error = err
          }
        })
        .render(this.$refs.paypal);
    }, paid () {
      //redirect to soshome
      this.$router.push( {name: 'Profile_home'} )

    }
  }

}
</script>

<style scoped>
    body {
      background-color: rgb(248, 247, 247);
    }
    #text {
      font-family: Arial, Helvetica, sans-serif;
      font-size: 16px;
    }
    body > .grid {
      height: 100%;
    }
    .image {
        margin-top: -100px;
    }
    .column {
        margin-top: 5%;
        max-width: 450px;
    }
</style>